'use strict';

module.exports = function(PixelTimeService) {
  return {
    restrict: 'E',
    template:
      '<div class="absent-time" data-ng-class="{\'absent-time--absence\': !absentTime.available}" data-ng-repeat="absentTime in absentTimes" data-ng-style="absentTime"></div>',
    replace: true,
    scope: {
      workingHours: '=',
    },
    link: function($scope, $element) {
      $scope.absentTimes = [];
      var times = $scope.workingHours.times;
      $scope.available = $scope.workingHours.available;

      if ($scope.available && times) {
        if (times[0]) {
          $scope.absentTimes.push({
            top: 0,
            available: $scope.workingHours.available,
            height: PixelTimeService.minutesToPixel(times[0].start),
          });
        }

        if (times.length === 1) {
          $scope.absentTimes.push({
            bottom: 0,
            available: $scope.workingHours.available,
            top: PixelTimeService.minutesToPixel(times[0].end),
          });
        } else if (times.length === 2) {
          $scope.absentTimes.push({
            top: PixelTimeService.minutesToPixel(times[0].end),
            available: $scope.workingHours.available,
            height: PixelTimeService.minutesToPixel(times[1].start - times[0].end, true),
          });

          $scope.absentTimes.push({
            top: PixelTimeService.minutesToPixel(times[1].end),
            available: $scope.workingHours.available,
            bottom: 0,
          });
        }
      } else {
        $scope.absentTimes.push({
          top: 0,
          available: $scope.workingHours.available,
          bottom: 0,
        });
      }
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/modules/calendar/absentTimesDirective.js